import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import { LoginResponseType, LoginType } from '../../types/apiTypes';

const useLogin = () => {
  return useMutation({
    mutationFn: async (
      loginCredentials: LoginType
    ): Promise<LoginResponseType | null> => {
      if (!loginCredentials) return null;

      const params = new URLSearchParams({ ...loginCredentials }).toString();

      const URL = `${import.meta.env.VITE_API_TOKEN_URL}?${params}`;

      const { data } = await axiosClient.post<LoginResponseType>(URL);

      return data;
    },
  });
};

export default useLogin;
